import { Outlet, Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import BottomTabs from "./BottomTabs";
import LoadingOverlay from "../LoadingOverlay";
import { useAuth } from "../../contexts/AuthContext";

export default function Layout() {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingOverlay />;
  }

  return (
    <div className="min-h-screen bg-linen">
      <header className="md:hidden fixed top-0 inset-x-0 z-50 h-12 bg-cream border-b border-stone flex items-center px-4">
        <Link to="/" className="font-display text-lg font-bold text-walnut">
          Good <span className="text-terracotta">Place</span>
        </Link>
      </header>
      <Sidebar />
      <main className="md:ml-60 pb-20 md:pb-6 px-4 md:px-8 pt-[72px] md:pt-6">
        <Outlet />
      </main>
      <BottomTabs />
    </div>
  );
}
